import TileWMSClass, * as TileWMSModule from './../../node_modules/ol/source/TileWMS.js';

class TileWMS extends TileWMSClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in TileWMSModule) {
    if (key !== "default") {
        TileWMS[key] = TileWMSModule[key];
    }
}

export default TileWMS;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/TileWMS.js';